import { unmaskPhoneNumber } from '../../../services/masks';
import { normalizeDocument, onlyDigits } from '../../../shared/documents';

import { ActivationFormState } from '../types';

export const PAGARME_BANK_HOLDER_NAME_MAX_LENGTH = 30;

export const normalizePagarmeBankHolderName = (value: string): string =>
  String(value || '').trim().slice(0, PAGARME_BANK_HOLDER_NAME_MAX_LENGTH);

export const toBrazilianBirthdate = (value: string): string => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) return raw;
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [yyyy, mm, dd] = raw.split('-');
    return `${dd}/${mm}/${yyyy}`;
  }
  return raw;
};

export const toInputBirthdate = (value: string): string => {
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    const [dd, mm, yyyy] = value.split('/');
    return `${yyyy}-${mm}-${dd}`;
  }
  return value;
};

export const normalizeComplementary = (value: string): string => {
  const normalized = String(value || '').trim();
  return normalized || 'Sem complemento';
};

export const normalizeReferencePoint = (value: string): string => {
  const normalized = String(value || '').trim();
  return normalized || 'Sem referência';
};

export const toPagarmePhoneNumbers = (
  value: string
): Array<{ ddd: number; number: number; type: 'mobile' }> => {
  let digits = unmaskPhoneNumber(String(value || ''));
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
    digits = digits.slice(2);
  }
  if (!digits || digits.length < 10) return [];

  const ddd = Number(digits.slice(0, 2));
  const number = Number(digits.slice(2));
  if (!ddd || !number) return [];

  return [{ ddd, number, type: 'mobile' }];
};

export const normalizeRecipientDocument = (
  value: string,
  recipientType: ActivationFormState['recipientType']
): string =>
  recipientType === 'corporation' ? normalizeDocument(value) : onlyDigits(value);

export const normalizeBankHolderDocument = (
  value: string,
  recipientType: ActivationFormState['recipientType'],
  bankHolderType?: ActivationFormState['bankHolderType']
): string => {
  const holderType = bankHolderType || (recipientType === 'corporation' ? 'company' : 'individual');
  return holderType === 'company' ? normalizeDocument(value) : onlyDigits(value);
};

export const getActivationValue = (
  payload: Record<string, unknown> | undefined,
  path: string,
  fallback = ''
): string => {
  if (!payload) return fallback;
  const value = path.split('.').reduce<unknown>((current, key) => {
    if (current && typeof current === 'object') {
      return (current as Record<string, unknown>)[key];
    }
    return undefined;
  }, payload);
  return value === undefined || value === null ? fallback : String(value);
};
